/**
 * groupUserRelation模块接口列表
 */
import $http from '../utils/http' // 导入http中创建的axios实例

const groupUserRelation = {
  // 增加groupUserRelation关联表
  createGroupUserRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupUserRelation/create`, params)
  },
  // 删除groupUserRelation关联表
  deleteGroupUserRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupUserRelation/deleteByGroupIdAndUserId`, params)
  }
}

export default groupUserRelation



// WEBPACK FOOTER //
// ./src/api/groupUserRelation.js